// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fWgf","question":"styles_question__3BhqZ","description":"styles_description__1A8OI"};